// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Completion,
} from './';

export default {
  path: 'completion',
  name: 'Completion',
  childRoutes: [
    { path: 'completion', name: 'Completion', component: Completion, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/completion/route.js